import React from "react";
import styled from "styled-components";
import css from "@styled-system/css";
import { Wrapper } from "../../../../Wrapper";
import { Stream, Title, Description, Button } from "../../styled";
import { desktop } from "../../../../../theme";

import { List, Counter } from "../../../../OrderedList";

import bortprovodnik from "./bortprovodnik.jpg";
import tonys_wild_life from "./tonys_wild_life.jpg";
import nagasakibiopark from "./nagasakibiopark.jpg";
import lifehacksTik from "./lifehacks.tik.jpg";
import mathAndMagic from "./math.and.magic.jpg";

const tiktoks = {
  bortprovodnik,
  tonys_wild_life,
  nagasakibiopark,
  "lifehacks.tik": lifehacksTik,
  "math.and.magic": mathAndMagic,
};

const Layout = styled("div")(
  css({
    [desktop]: {
      width: "77%",
    },
  })
);
const DescriptionStyled = styled(Description)(
  css({
    color: "#fff",
  })
);
const StreamStyled = styled(Stream)(
  css({
    backgroundColor: "#52B78B",
    pt: [50, 145],
    mb: [-40, -350],
    pb: [40, 350],
  })
);

const TitleStyled = styled(Title)(
  css({
    my: 0,
    backgroundImage: "none",
  })
);

const TiktokTitle = styled("div")(
  css({
    fontSize: [2, 3],
    mb: 15,
  })
);
const TiktokDescription = styled("div")(
  css({
    fontSize: [1, 2],
    mb: 30,
  })
);

const TiktokPreview = styled("div")(
  css({
    display: "none",
    position: "absolute",
    height: "100%",
    width: "22%",
    left: "100%",
    top: 0,
    ml: 16,
    borderRadius: 20,
    [desktop]: {
      display: "block",
    },
    backgroundSize: "cover",
    backgroundPosition: "center",
  }),
  ({ $image }) => ({
    backgroundImage: `url(${$image})`,
  })
);

const CounterStyled = styled(Counter)(
  css({
    display: "flex",
  })
);

const Tiktok = ({ account, children }) => (
  <li>
    <div>
      <CounterStyled />
    </div>
    <div>
      <TiktokPreview $image={tiktoks[account]} />
      <TiktokTitle>@{account}</TiktokTitle>
      <TiktokDescription>{children}</TiktokDescription>
      <Button
        as={"a"}
        target="_blank"
        rel="noopener noreferrer"
        href={`https://www.tiktok.com/@${account}`}
      >
        Узнать
      </Button>
    </div>
  </li>
);

const Tiktoks = styled(List)(
  css({
    li: {
      position: "relative",
      mt: 0,
      mb: 18,
    },
  })
);

export const StopContent = () => (
  <StreamStyled id="stop-content" withoutWave>
    <Wrapper>
      <TitleStyled>
        <span role="img" aria-label="stop">
          🛑
        </span>{" "}
        STOP CONTENT
      </TitleStyled>
      <Layout>
        <DescriptionStyled>
          <p>
            Если ты&nbsp;не&nbsp;хочешь заморачиваться над контентом,
            то&nbsp;в&nbsp;TikTok&rsquo;e можно просто залипнуть вместе
            на&nbsp;контенте других пользователей&nbsp;&mdash; не&nbsp;хуже, чем
            в&nbsp;ютубчике!
          </p>
          <p>
            Скролим свеженькую подборочку ТОП-5 интересных аккаунтов
            и&nbsp;забираем в&nbsp;&laquo;избранное&raquo;.
          </p>
        </DescriptionStyled>
        <Tiktoks>
          <Tiktok account="bortprovodnik">
            Аккаунт бортпроводника одной из&nbsp;российских авиакомпаний.
            Он&nbsp;отвечает на&nbsp;самые частые вопросы пассажиров,
            опровергает мифы о&nbsp;самолётах и&nbsp;рассказывает
            о&nbsp;странных ситуациях на&nbsp;борту. Собрался в&nbsp;полёт?
            Залипни тут и&nbsp;не&nbsp;повторяй ошибок, о&nbsp;которых
            он&nbsp;говорит.
          </Tiktok>
          <Tiktok account="tonys_wild_life">
            Автор этого аккаунта снимает тиктоки с&nbsp;дикими волками
            и&nbsp;рептилиями. Тут точно будет над чем позалипать вечерочек
            другой.
          </Tiktok>
          <Tiktok account="nagasakibiopark">
            Ты&nbsp;когда-нибудь был в&nbsp;японском зоопарке? Мы&nbsp;тоже нет.
            А&nbsp;владелец этого аккаунта постоянно даёт возможность посмотреть
            на&nbsp;жителей зоопарка и&nbsp;залипнуть на&nbsp;их&nbsp;жизни.
          </Tiktok>
          <Tiktok account="lifehacks.tik">
            То, что нужно каждому бумеру. Аккаунт с&nbsp;многочисленными
            лайфхаками как в&nbsp;быту, так и&nbsp;в&nbsp;жизни в&nbsp;целом.
            Но&nbsp;и&nbsp;зумерам будет на&nbsp;чём залипнуть.
          </Tiktok>
          <Tiktok account="math.and.magic">
            50-летний учитель математики из&nbsp;Челябинска Петр Земсков пришёл
            в&nbsp;TikTok и&nbsp;покорил чуть больше 632 тысяч аккаунтов!
            Он&nbsp;доказывает за&nbsp;60&nbsp;секунд теорему Пифагора
            и&nbsp;решает всё, что можно решить.
          </Tiktok>
        </Tiktoks>
      </Layout>
    </Wrapper>
  </StreamStyled>
);
